export const NEWS_PROFILE_ROUTE = 'newsprofile';
